var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"font-roboto"},[_c('Breadcrumbs',{attrs:{"main":"","title":_vm.$t('lbl_EMPBE_AutoReport')}}),_c('div',{staticClass:"Wrapper"},[_c('DataGrid')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }